import firebase from "../firebase";
import ITemplateData from "../types/template.type"

const db = firebase.firestore().collection("/templates");

class TemplateDataService {
  getAll() {
    return db;
  }

  create(template: ITemplateData) {
    return db.add(template);
  }

  update(id: string, value: any) {
    return db.doc(id).update(value);
  }

  delete(id: string) {
    return db.doc(id).delete();
  }
}

const templateDataService = new TemplateDataService();

export default templateDataService;
